function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32.8125 22.5C32.8125 28.1954 28.1954 32.8125 22.5 32.8125C16.8046 32.8125 12.1875 28.1954 12.1875 22.5C12.1875 16.8046 16.8046 12.1875 22.5 12.1875C28.1954 12.1875 32.8125 16.8046 32.8125 22.5Z",
  stroke: "#F0F0F5",
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("line", {
  x1: 40.25,
  y1: 22.5625,
  x2: 36.625,
  y2: 22.5625,
  stroke: "#F25022",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("line", {
  x1: 8.375,
  y1: 22.5625,
  x2: 4.75,
  y2: 22.5625,
  stroke: "#F25022",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("line", {
  x1: 40.25,
  y1: 22.5625,
  x2: 36.625,
  y2: 22.5625,
  stroke: "#F0F0F5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("line", {
  x1: 8.375,
  y1: 22.5625,
  x2: 4.75,
  y2: 22.5625,
  stroke: "#F0F0F5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("line", {
  x1: 37.8407,
  y1: 31.4291,
  x2: 34.7014,
  y2: 29.6166,
  stroke: "#F0F0F5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref8 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip1)"
}, /*#__PURE__*/React.createElement("line", {
  x1: 10.2361,
  y1: 15.4916,
  x2: 7.0968,
  y2: 13.6791,
  stroke: "#F0F0F5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref9 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip2)"
}, /*#__PURE__*/React.createElement("line", {
  x1: 31.3209,
  y1: 37.9032,
  x2: 29.5084,
  y2: 34.7639,
  stroke: "#F0F0F5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref10 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip3)"
}, /*#__PURE__*/React.createElement("line", {
  x1: 15.3834,
  y1: 10.2986,
  x2: 13.5709,
  y2: 7.1593,
  stroke: "#F0F0F5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref11 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip4)"
}, /*#__PURE__*/React.createElement("line", {
  x1: 22.4375,
  y1: 40.25,
  x2: 22.4375,
  y2: 36.625,
  stroke: "#F0F0F5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref12 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip5)"
}, /*#__PURE__*/React.createElement("line", {
  x1: 22.4375,
  y1: 8.375,
  x2: 22.4375,
  y2: 4.75,
  stroke: "#F0F0F5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref13 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip6)"
}, /*#__PURE__*/React.createElement("line", {
  x1: 13.5709,
  y1: 37.8407,
  x2: 15.3834,
  y2: 34.7014,
  stroke: "#F0F0F5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref14 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip7)"
}, /*#__PURE__*/React.createElement("line", {
  x1: 29.5084,
  y1: 10.2361,
  x2: 31.3209,
  y2: 7.09681,
  stroke: "#F0F0F5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref15 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip8)"
}, /*#__PURE__*/React.createElement("line", {
  x1: 7.0968,
  y1: 31.3209,
  x2: 10.2361,
  y2: 29.5084,
  stroke: "#F0F0F5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref16 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip9)"
}, /*#__PURE__*/React.createElement("line", {
  x1: 34.7014,
  y1: 15.3834,
  x2: 37.8407,
  y2: 13.5709,
  stroke: "#F0F0F5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M31.875 22.5C31.875 27.6777 27.6777 31.875 22.5 31.875C17.3223 31.875 13.125 27.6777 13.125 22.5C13.125 17.3223 17.3223 13.125 22.5 13.125C27.6777 13.125 31.875 17.3223 31.875 22.5Z",
  fill: "#FFB900"
});

var _ref18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  x: 33.9922,
  y: 26.9699,
  width: 7.5,
  height: 3.75,
  rx: 1.875,
  transform: "rotate(30 33.9922 26.9699)",
  fill: "white"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip1"
}, /*#__PURE__*/React.createElement("rect", {
  x: 6.38763,
  y: 11.0324,
  width: 7.5,
  height: 3.75,
  rx: 1.875,
  transform: "rotate(30 6.38763 11.0324)",
  fill: "white"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip2"
}, /*#__PURE__*/React.createElement("rect", {
  x: 30.2175,
  y: 32.1172,
  width: 7.5,
  height: 3.75,
  rx: 1.875,
  transform: "rotate(60 30.2175 32.1172)",
  fill: "white"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip3"
}, /*#__PURE__*/React.createElement("rect", {
  x: 14.28,
  y: 4.51263,
  width: 7.5,
  height: 3.75,
  rx: 1.875,
  transform: "rotate(60 14.28 4.51263)",
  fill: "white"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip4"
}, /*#__PURE__*/React.createElement("rect", {
  x: 24.375,
  y: 34.6875,
  width: 7.5,
  height: 3.75,
  rx: 1.875,
  transform: "rotate(90 24.375 34.6875)",
  fill: "white"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip5"
}, /*#__PURE__*/React.createElement("rect", {
  x: 24.375,
  y: 2.8125,
  width: 7.5,
  height: 3.75,
  rx: 1.875,
  transform: "rotate(90 24.375 2.8125)",
  fill: "white"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip6"
}, /*#__PURE__*/React.createElement("rect", {
  x: 18.03,
  y: 33.9922,
  width: 7.5,
  height: 3.75,
  rx: 1.875,
  transform: "rotate(120 18.03 33.9922)",
  fill: "white"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip7"
}, /*#__PURE__*/React.createElement("rect", {
  x: 33.9675,
  y: 6.38763,
  width: 7.5,
  height: 3.75,
  rx: 1.875,
  transform: "rotate(120 33.9675 6.38763)",
  fill: "white"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip8"
}, /*#__PURE__*/React.createElement("rect", {
  x: 12.8828,
  y: 30.2176,
  width: 7.5,
  height: 3.75,
  rx: 1.875,
  transform: "rotate(150 12.8828 30.2176)",
  fill: "white"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip9"
}, /*#__PURE__*/React.createElement("rect", {
  x: 40.4874,
  y: 14.2801,
  width: 7.5,
  height: 3.75,
  rx: 1.875,
  transform: "rotate(150 40.4874 14.2801)",
  fill: "white"
})));

function SvgSunny(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunny);
export default __webpack_public_path__ + "static/media/sunny.c0e7b149.svg";
export { ForwardRef as ReactComponent };